<div class="top-header-filters flex align-items-center gap-3">
  <ng-content select="filters-section"></ng-content>
  @if ((gridView$ | async); as view) {

    @if(view !=='medium' && view !=='small'){
      <div class="top-header-date flex flex-column align-items-start">
        <span class="webkit-box-one-line label-small-regular">{{dateTime().date}}</span>
        <span class="webkit-box-one-line label-small-regular">{{dateTime().time}}</span>
      </div>
    }
  
}
</div>